import { Component, OnInit, Input, DoCheck, Output, EventEmitter } from '@angular/core';
import { CalculationService } from '../services/calculation.service';
import { FormDataService } from '../services/form-data.service';

@Component({
  selector: 'app-protect-custom',
  templateUrl: './protect-custom.component.html',
  styleUrls: ['./protect-custom.component.scss'],
  standalone: false
})
export class ProtectCustomComponent implements OnInit, DoCheck {
  @Input('dataJSON') dataJSON: any;
  @Input('hideIllnessWhenOver65Years') hideIllnessWhenOver65Years: boolean;
  @Output('sendJSONWithPrem') sendJSONWithPrem = new EventEmitter<any>();
  @Output('exportReturnedData') exportReturnetData = new EventEmitter<any>();

  private bornDate: string;
  private years: number;
  private amoutOfMoney: number;
  private currency: string; // "BGN" or "EUR"
  private selectedPaymentType: number; // "1" / "12"
  public isExtendedPartActive: boolean = false;
  private isCheckboxesGroup1Active: boolean = false;
  private isCheckboxesGroup2Active: boolean = false;
  private isCheckboxesGroup3Active: boolean = false;
  private isCrillDescriptionActive: boolean = false;
  private isSecondMedicalOpinionDescriptionActive: boolean = false;
  private crill: string;
  private secondMedOp: string;
  private isCrillAndSecMedOPChecked: boolean = false;
  public isCrillAndSecMedOPUnchecked: boolean = false;
  private death: string;
  private isDeathChecked: boolean = false;
  private stayAtHospital: number;
  private isStayAtHospitalByAccidentChecked: boolean = false;
  private isStayAtHospitalByDiseaseChecked: boolean = false;
  private expenditureForMedicines: number;
  private isExpenditureForMedicinesByAccidentChecked: boolean = false;
  private isExpenditureForMedicinesByDiseaseChecked: boolean = false;
  private temporraryLossOfEmployment: number;
  private isTemporraryLossOfEmploymentByAccidentChecked: boolean = false;
  private isTemporraryLossOfEmploymentByDiseaseChecked: boolean = false;
  private longTermLossOfEmployment: number;
  private isLongTermLossOfEmploymentByAccidentChecked: boolean = false;
  private isLongTermLossOfEmploymentByDiseaseChecked: boolean = false;
  private manPrem: number;
  private previousManPrem: number;
  private returnedData: any = [];
  jsonObjectWithPremium: any = {};
  public isCheckboxActive:boolean = false;
  public noCheckedCheckboxes = false;
  public removePackages: boolean = false;


  // variables that show or hide some message on the screen
  private isThereEmptyField: boolean = false;
  private isBornDateCharactersCorrect: boolean = true;
  private isBornDateMonthAndDayCorrect: boolean = true;
  private isBornDateLengthCorrect: boolean = true;
  private isBornDateCorrect: boolean = true;
  private isYearsOfDurationCorrect: boolean = true;

  constructor(private calculationService: CalculationService, private data: FormDataService) { }

  ngOnInit() {
    this.data.currentRemovePackages.subscribe(removePackages => this.removePackages = removePackages);
  }

  ngDoCheck() {
    this.bornDate = this.dataJSON.bornDate;
    this.years = this.dataJSON.years;
    this.amoutOfMoney = this.dataJSON.amoutOfMoney;
    this.currency = this.dataJSON.currency;
    this.selectedPaymentType = this.dataJSON.selectedPaymentType;
    // console.log('protect - this.manPrem, this.previousManPrem', this.manPrem, this.previousManPrem);
    // if (this.manPrem != this.previousManPrem) {
    //   this.changePrem(this.jsonObjectWithPremium);
    //   this.previousManPrem = this.manPrem;
    // }
    if(this.removePackages){
      this.isDeathChecked = false;
      this.isTemporraryLossOfEmploymentByAccidentChecked = false;
      this.isTemporraryLossOfEmploymentByDiseaseChecked = false;
      this.isLongTermLossOfEmploymentByAccidentChecked = false;
      this.isLongTermLossOfEmploymentByDiseaseChecked = false;
      this.isStayAtHospitalByAccidentChecked = false;
      this.isStayAtHospitalByDiseaseChecked = false;
      this.isExpenditureForMedicinesByAccidentChecked = false;
      this.isExpenditureForMedicinesByDiseaseChecked = false;
      this.isCrillDescriptionActive = false;
      this.isCrillAndSecMedOPChecked = false;
      this.isCrillAndSecMedOPUnchecked = true;
      this.crill = "N";
      this.secondMedOp = "N";
      this.data.changePackageState(false);
    }
    this.exportReturnetData.emit(this.returnedData);
  }

  showHideExtendedPart() {
    this.isExtendedPartActive = !this.isExtendedPartActive;
  }

  showHideCheckboxesGroup(numberOfGroup: number) {
    switch (numberOfGroup) {
      case 1: this.isCheckboxesGroup1Active = !this.isCheckboxesGroup1Active; break;
      case 2: this.isCheckboxesGroup2Active = !this.isCheckboxesGroup2Active; break;
      case 3: this.isCheckboxesGroup3Active = !this.isCheckboxesGroup3Active; break;
    }
  }

  showHideCrillDescription() {
    this.isCrillDescriptionActive = !this.isCrillDescriptionActive;
  }

  showHideSecondMedicalOpinionDescription() {
    this.isSecondMedicalOpinionDescriptionActive = !this.isSecondMedicalOpinionDescriptionActive;
  }

  checkboxesChangesHandle(whichCheckboxIsClicked: string) {
    switch (whichCheckboxIsClicked) {
      case 'longTermLossOfEmploymentByAccident': this.isLongTermLossOfEmploymentByDiseaseChecked = false; break;
      case 'longTermLossOfEmploymentByDisease': this.isLongTermLossOfEmploymentByAccidentChecked = false; break;
      case 'temporraryLossOfEmploymentByAccident':
        this.isTemporraryLossOfEmploymentByDiseaseChecked = false;
        this.isExpenditureForMedicinesByDiseaseChecked = false; break;
      case 'temporraryLossOfEmploymentByDisease':
        this.isTemporraryLossOfEmploymentByAccidentChecked = false;
        this.isExpenditureForMedicinesByDiseaseChecked = false; break;
      case 'stayAtHospitalByAccident': this.isStayAtHospitalByDiseaseChecked = false; break;
      case 'stayAtHospitalByDisease': this.isStayAtHospitalByAccidentChecked = false; break;
      case 'expenditureForMedicinesByAccident':
        this.isExpenditureForMedicinesByDiseaseChecked = false; break;
      case 'expenditureForMedicinesByDisease':
        this.isTemporraryLossOfEmploymentByAccidentChecked = false;
        this.isExpenditureForMedicinesByAccidentChecked = false;
        this.isTemporraryLossOfEmploymentByDiseaseChecked = true; break;
    }
  }

  changePrem(newJSONWithPrem: any) {
    this.sendJSONWithPrem.emit(newJSONWithPrem);
  }

  addCrillAndSecondMedicalOpinion() {
    this.isCrillAndSecMedOPChecked = true;
    this.isCrillAndSecMedOPUnchecked = false;
    this.calculate();
  }

  removeCrillAndSecondMedicalOpinion() {
    this.isCrillAndSecMedOPChecked = false;
    this.isCrillAndSecMedOPUnchecked = true;
    this.calculate();
  }

  checkCheckboxes() {
    if(this.isLongTermLossOfEmploymentByAccidentChecked || this.isLongTermLossOfEmploymentByDiseaseChecked || this.isTemporraryLossOfEmploymentByAccidentChecked ||
      this.isTemporraryLossOfEmploymentByDiseaseChecked || this.isStayAtHospitalByAccidentChecked || this.isStayAtHospitalByDiseaseChecked || this.isExpenditureForMedicinesByAccidentChecked ||
      this.isExpenditureForMedicinesByDiseaseChecked || this.isDeathChecked || this.isCrillAndSecMedOPChecked) {
      return true;
    }else{
      return false;
    }
  }

  calculate() {
    this.returnedData = [];

    if(this.checkCheckboxes()) {
          // Check which checkboxes are selected and change the values by current selected
    if (this.isCrillAndSecMedOPChecked) {
      this.crill = "Y";
      this.secondMedOp = "Y";
    }
    else {
      this.crill = "N";
      this.secondMedOp = "N";
    }

    if (this.isDeathChecked) {
      this.death = "Y";
    }
    else {
      this.death = "N";
    }

    if (this.isStayAtHospitalByAccidentChecked) {
      this.stayAtHospital = 1 * 1;
    }
    else if (this.isStayAtHospitalByDiseaseChecked) {
      this.stayAtHospital = 2 * 1;
    }
    else {
      this.stayAtHospital = 0 * 1;
    }

    if (this.isExpenditureForMedicinesByAccidentChecked) {
      this.expenditureForMedicines = 1 * 1;
    }
    else if (this.isExpenditureForMedicinesByDiseaseChecked) {
      this.expenditureForMedicines = 2 * 1;
    }
    else {
      this.expenditureForMedicines = 0 * 1;
    }

    if (this.isTemporraryLossOfEmploymentByAccidentChecked) {
      this.temporraryLossOfEmployment = 1 * 1;
    }
    else if (this.isTemporraryLossOfEmploymentByDiseaseChecked) {
      this.temporraryLossOfEmployment = 2 * 1;
    }
    else {
      this.temporraryLossOfEmployment = 0 * 1;
    }

    if (this.isLongTermLossOfEmploymentByAccidentChecked) {
      this.longTermLossOfEmployment = 1 * 1;
    }
    else if (this.isLongTermLossOfEmploymentByDiseaseChecked) {
      this.longTermLossOfEmployment = 2 * 1;
    }
    else {
      this.longTermLossOfEmployment = 0 * 1;
    }

    // Validation - check are all inputs correct
    this.isThereEmptyField = false;
    this.isBornDateCharactersCorrect = true;
    this.isBornDateMonthAndDayCorrect = true;
    this.isBornDateLengthCorrect = true;
    this.isBornDateCorrect = true;
    this.isYearsOfDurationCorrect = true;

    if (!this.bornDate || !this.years || !this.amoutOfMoney || !this.currency || !this.selectedPaymentType) {
      this.isThereEmptyField = true;
    }
    else {
      this.isThereEmptyField = false;

      if (new RegExp(/^[0-9\-]+$/).test(this.bornDate)) {
        this.isBornDateCharactersCorrect = true;

        const dateParts = this.bornDate.split("-");
        const month = parseInt(dateParts[1], 10);
        const day = parseInt(dateParts[2], 10);
        
        if (month >= 1 && month <= 12 && day >= 1 && day <= 31) {
            this.isBornDateMonthAndDayCorrect = true;

          if (new String(this.bornDate).toString().length === 10) {
            this.isBornDateLengthCorrect = true;

            let userYears = new Date().getFullYear() - new Date(this.bornDate).getFullYear();

            if (userYears >= 14 && userYears <= 60) {
              this.isBornDateCorrect = true;

              if ((userYears + this.years) <= 70) {
                this.isBornDateCorrect = true;

                if (this.years >= 10 && this.years <= 30) {
                  this.isYearsOfDurationCorrect = true;

                  // send the data to the service
                  this.calculationService.sendDataForCalculation(
                    this.crill, // при включени тежки заболявания - "Y" or "N"
                    this.secondMedOp, // при включено второ медицинско мнение - - "Y" or "N"
                    this.bornDate,
                    this.years,
                    this.amoutOfMoney,
                    this.currency,
                    this.selectedPaymentType,
                    this.death, //  'Y' -> Включено СМЪРТ ОТ ЗЛОПОЛУКА, 'N' -> Без СМЪРТ ОТ ЗЛОПОЛУКА
                    this.stayAtHospital, //  0 -> Без БОЛНИЧЕН ПРЕСТОЙ, 1 -> Включен БОЛНИЧЕН ПРЕСТОЙ ОТ ЗЛОПОЛУКА, 2 -> Включен БОЛНИЧЕН ПРЕСТОЙ ОТ ЗЛОПОЛУКА ИЛИ ЗАБОЛЯВАНЕ
                    this.expenditureForMedicines, //  0 -> Без РАЗХОДИ ЗА ЛЕКАРСТВА, 1 -> Включен РАЗХОДИ ЗА ЛЕКАРСТВА ОТ ЗЛОПОЛУКА, 2 -> Включен РАЗХОДИ ЗА ЛЕКАРСТВА ОТ ЗЛОПОЛУКА ИЛИ ЗАБОЛЯВАНЕ
                    this.temporraryLossOfEmployment, // 0 -> Без ВРЕМЕННА ЗАГУБА НА ТРУДОСПОСОБНОСТ,   1 -> Включена ВРЕМЕННА ЗАГУБА НА ТРУДОСПОСОБНОСТ ОТ ЗЛОПОЛУКА, 2 -> Включена ВРЕМЕННА ЗАГУБА НА ТРУДОСПОСОБНОСТ ОТ ЗЛОПОЛУКА ИЛИ ЗАБОЛЯВАНЕ
                    this.longTermLossOfEmployment //0 -> Без ТРАЙНА ЗАГУБА НА ТРУДОСПОСОБНОСТ, 1 -> Включен ТРАЙНА ЗАГУБА НА ТРУДОСПОСОБНОСТ ОТ ЗЛОПОЛУКА, 2 -> Включен ТРАЙНА ЗАГУБА НА ТРУДОСПОСОБНОСТ ОТ ЗЛОПОЛУКА ИЛИ ЗАБОЛЯВАНЕ
                  ).subscribe(
                    resultData => {
                      this.returnedData.push(resultData);
                      // console.log("The returndData: ", this.returnedData);
                      // console.log("The result: ", resultData);
                      // console.log("The manPrem: ", this.returnedData[0].payload.CalcPrem[0].PREMIUM);
                      // construct JSON including all checkboxes values and returned premium
                      this.jsonObjectWithPremium = {
                        manPrem: this.returnedData[0].payload.CalcPrem[0].PREMIUM,
                        selectedPackage: "custom",
                        customPackage: "Y",
                        crill: this.crill,
                        secondMedOp: this.secondMedOp,
                        death: this.death,
                        stayAtHospital: this.stayAtHospital,
                        expenditureForMedicines: this.expenditureForMedicines,
                        temporraryLossOfEmployment: this.temporraryLossOfEmployment,
                        longTermLossOfEmployment: this.longTermLossOfEmployment
                      }
                      this.manPrem = this.returnedData[0].payload.CalcPrem[0].PREMIUM;
                      this.changePrem(this.jsonObjectWithPremium);
                    },
                    err => {
                      console.log("Error has occured: ", err);
                    }
                    );
                }
                else {
                  this.isYearsOfDurationCorrect = false;
                }
              }
              else {
                this.isBornDateCorrect = false;
              }
            }
            else {
              this.isBornDateCorrect = false;
            }
          }
          else {
            this.isBornDateLengthCorrect = false;
          }
        }
        else {
          this.isBornDateMonthAndDayCorrect = false;
        }
      }
      else {
        this.isBornDateCharactersCorrect = false;
      }
    }
     this.noCheckedCheckboxes = false;
    }else {
     this.noCheckedCheckboxes = true;
     return ;
    }
  }
}
